import { render } from "./AppNavItemLink.vue?vue&type=template&id=f18db808"
import script from "./AppNavItemLink.vue?vue&type=script&lang=js"
export * from "./AppNavItemLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__